import "./AppBar.scss";

import React from "react";

export default function AppBar() {
  return <nav className="navbar-app">vPu-Space</nav>;
}
